export function configureFetchApi(): void {
  const realFetch = window.fetch
  window.fetch = (url: any, opts: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      // authenticate
      if (url.endsWith('/api/v1/auth') && opts.method === 'POST') {
        // get parameters from post request
        const params = JSON.parse(opts.body)

        realFetch(url, opts).then(response => {
          resolve(response)
        }).catch(error => reject(error))

        return
      }

      // pass through any requests not handled above
      realFetch(url, opts).then(response => resolve(response)).catch(response => reject(response))
    })
  }
}
